"use strict";
/*
* Offical Subtypes of Treez
* Make sure all considerations have been made before editing.
* https://docs.google.com/spreadsheets/d/13ayXJ4nVWw3iOP4w5V2kctPYByUZSgtLneVtfeS4-oE/edit#gid=0
*/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.allSubtypes = exports.topicalSubtypes = exports.tinctureSubtypes = exports.prerollSubtypes = exports.plantSubtypes = exports.pillSubtypes = exports.nonInvSubtypes = exports.miscSubtypes = exports.merchSubtypes = exports.flowerSubtypes = exports.extractSubtypes = exports.edibleSubtypes = exports.cbdSubtypes = exports.cartridgeSubtypes = exports.beverageSubtypes = void 0;
const lodash_1 = __importDefault(require("lodash"));
exports.beverageSubtypes = [
    'BEER',
    'COFFEE',
    'DISSOLVABLE',
    'ELIXIR',
    'JUICE',
    'SHOT',
    'SODA',
    'TEA',
    'TONIC',
    'WATER',
    'OTHER',
];
exports.cartridgeSubtypes = [
    '510 THREAD',
    'AIRGRAFT POD',
    'ALL-IN-ONE',
    'CCELL',
    'CURED RESIN',
    'DISTILLATE',
    'G PEN POD',
    'HANU POD',
    'HASH',
    'LIVE RESIN',
    'PAX ERA POD',
    'POD',
    'READY TO USE',
    'SAUCE PEN',
    'OTHER',
];
exports.cbdSubtypes = [
    'CAPSULE',
    'CREAM',
    'OIL',
    'TINCTURE',
    'OTHER',
];
exports.edibleSubtypes = [
    'BAKED GOOD',
    'BUTTER',
    'CHEW',
    'CHOCOLATE',
    'COOKIE',
    'GUM',
    'GUMMY',
    'HARD CANDY',
    'LOZENGE',
    'MINTS',
    'OIL',
    'SAVORY',
    'SUBLINGUAL',
    'OTHER',
];
exports.extractSubtypes = [
    'BADDER',
    'BUDDER',
    'CAVIAR',
    'CRUMBLE',
    'CRYSTALLINE',
    'CURED RESIN',
    'DIAMONDS',
    'DISTLLATE',
    'DRY SIFT',
    'FLOWER ROSIN',
    'FSO',
    'HASH ROSIN',
    'HASH',
    'ICE WATER HASH',
    'ICE WAX',
    'ISOLATE',
    'JELLY',
    'LIVE RESIN BADDER',
    'LIVE RESIN BUDDER',
    'LIVE RESIN SUGAR',
    'LIVE RESIN',
    'LIVE ROSIN',
    'MOON ROCKS',
    'OIL',
    'POWDER HASH',
    'ROSIN BUDDER',
    'RSO',
    'SAUCE',
    'SHATTER',
    'SIFT ROSIN',
    'SORBET',
    'SUGAR',
    'TEMPLE BALL',
    'THC-A',
    'WAX',
    'OTHER',
];
exports.flowerSubtypes = [
    'BULK FLOWER',
    // INFUSED FLOWER',  Add back when Infused Flower is properly handled across all platforms
    'KIEF',
    'PRE-GROUND',
    'PRE-PACK SMALLS',
    'PRE-PACK',
    'SHAKE',
    'STRAIN SPECIFIC SHAKE',
    'INFUSED'
];
exports.merchSubtypes = [
    'ACCESSORY',
    'BATTERY',
    'BEVERAGE',
    'BONG',
    'BOOK',
    'CLOTHING',
    'DAB RIG',
    'GIFT CARD',
    'HAT',
    'HOODIE',
    'LIGHTER',
    'OIL RIG',
    'PIPE',
    'ROLLING PAPERS',
    'SNACK',
    'SWEATSHIRT',
    'T SHIRT',
    'VAPORIZER',
    'OTHER',
];
exports.miscSubtypes = [
    'BATH',
    'SOLID',
    'SUPPOSITORY',
    'LIQUID',
    'OTHER',
];
exports.nonInvSubtypes = [
    'MEMBERSHIP',
    'FEE',
    'GIFT CARD',
    'OTHER',
];
exports.pillSubtypes = [
    'CAPSULE',
    'CHEWABLE',
    'TABLET',
    'OTHER',
];
exports.plantSubtypes = [
    'CLONE',
    'FRESH WHOLE PLANT',
    'SEEDS',
];
exports.prerollSubtypes = [
    'FLOWER',
    'INFUSED',
    'SHAKE',
];
exports.tinctureSubtypes = [
    'DROPPER',
    'SPRAY',
    'SYRUP',
    'OTHER',
];
exports.topicalSubtypes = [
    'BALM',
    'CREAM',
    'GEL',
    'LOTION',
    'OIL',
    'PATCH',
    'SALVE',
    'SPRAY',
    'OTHER',
];
exports.allSubtypes = lodash_1.default.uniq([
    ...exports.beverageSubtypes,
    ...exports.cartridgeSubtypes,
    ...exports.cbdSubtypes,
    ...exports.edibleSubtypes,
    ...exports.extractSubtypes,
    ...exports.flowerSubtypes,
    ...exports.merchSubtypes,
    ...exports.miscSubtypes,
    ...exports.nonInvSubtypes,
    ...exports.pillSubtypes,
    ...exports.plantSubtypes,
    ...exports.prerollSubtypes,
    ...exports.tinctureSubtypes,
    ...exports.topicalSubtypes
]);
//# sourceMappingURL=data:application/json;base64,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